import { render } from "./defaultLayout.vue?vue&type=template&id=65333c70&scoped=true&ts=true"
import script from "./defaultLayout.vue?vue&type=script&lang=ts"
export * from "./defaultLayout.vue?vue&type=script&lang=ts"

import "./defaultLayout.vue?vue&type=style&index=0&id=65333c70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65333c70"]])

export default __exports__